import { Component, OnInit } from "@angular/core";
import { ElectionService } from "../../../shared/services/election.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModelCompanyprofile } from "../../../model/model.companyprofile";
import { CompanyService } from "../../../shared/services/company.service";
import {
  alertMessages,
  AlertService,
} from "../../../shared/services/alert.service";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: "app-admin-company-election-signup-modal",
  templateUrl: "./admin-company-election-signup-modal.component.html",
  styleUrls: ["./admin-company-election-signup-modal.component.scss"],
  standalone: false,
})
export class AdminCompanyElectionSignupModalComponent implements OnInit {
  public data: any;

  public electionId: string | null = null;
  public companyId: string = "";
  public areaId: string | null = null;

  public elections: any[] = [];
  public areas: any[] = [];

  public company: any | ModelCompanyprofile = {
    areaOfInterests: undefined,
    avatarUri: "",
    companyImageReferences: undefined,
    coverPhotoUri: "",
    description: "",
    descriptionDe: "",
    descriptionEn: "",
    descriptionFr: "",
    descriptionPt: "",
    educationLevels: undefined,
    facebookUri: "",
    googleUri: "",
    id: "",
    instagramUri: "",
    isCurrentUserConnected: false,
    isCurrentUserFavorite: false,
    linkedInUri: "",
    name: "",
    opportunitiesText: "",
    opportunitiesTextDe: "",
    opportunitiesTextEn: "",
    opportunitiesTextFr: "",
    opportunitiesTextPt: "",
    phoneNumber: "",
    primaryContact: {
      avatarUri: "",
      emailAddress: "",
      firstName: "",
      id: "",
      infix: "",
      lastName: "",
      phoneNumber: "",
    },
    regions: undefined,
    registrationNumber: "",
    sectorName: "",
    status: "",
    twitterUri: "",
    uniqueText: "",
    uniqueTextDe: "",
    uniqueTextEn: "",
    uniqueTextFr: "",
    uniqueTextPt: "",
    websiteUri: "",
  };

  constructor(
    public activeModal: NgbActiveModal,
    public electionService: ElectionService,
    public companyService: CompanyService,
    public alert: AlertService
  ) {}

  ngOnInit(): void {
    this.company = Object.assign({}, this.data);
    this.companyId = this.company.id;

    this.getActiveElections();
  }

  setAreas(electionId: string) {
    this.areaId = null;

    if (!electionId) {
      this.areas = [];
      return;
    }

    for (const election of this.elections) {
      if (election.id == electionId) {
        this.areas = Object.assign([], election.areas);
      }
    }
  }

  getActiveElections() {
    this.electionService.getActive().subscribe((response: any) => {
      this.elections = Object.assign([], response);
    });
  }

  valid() {
    let valid = true;

    if (!this.companyId || !this.electionId || !this.areaId) {
      valid = false;
    }

    return valid;
  }

  signUp() {
    if (!this.valid() || !this.electionId || !this.areaId || !this.companyId) {
      return;
    }

    this.companyService
      .createCompanyAwvlElectionProfile(
        this.companyId,
        this.electionId,
        this.areaId
      )
      .subscribe((response) => {
        this.alert.success(alertMessages.successDataSaved);

        this.activeModal.close(true);
      });
  }
}
